import type { Schemas } from '@beamx/shared';
import { request } from './client.js';

// Types derive from the backend OpenAPI contract (generated schema.d.ts).
export type MessageStatus = Schemas['MessageStatus'];
export type MessageListItem = Schemas['MessageListItem'];
export type MessagesPage = Schemas['MessagesPage'];
export type MessageSummary = Schemas['MessageSummary'];
export type MessageEventType = Schemas['MessageEventType'];
export type MessageEventSummary = Schemas['MessageEventSummary'];

/** Client-side query parameters for the activity list (not a response schema). */
export interface MessageFilter {
  status?: MessageStatus;
  templateKey?: string;
  toEmail?: string;
  from?: string;
  to?: string;
  skip?: number;
  take?: number;
}

export const messages = {
  list: (filter: MessageFilter = {}) => {
    const params = new URLSearchParams();
    if (filter.status) params.set('status', filter.status);
    if (filter.templateKey) params.set('template_key', filter.templateKey);
    if (filter.toEmail) params.set('to', filter.toEmail);
    if (filter.from) params.set('from', filter.from);
    if (filter.to) params.set('to', filter.to);
    if (filter.skip != null) params.set('skip', String(filter.skip));
    if (filter.take != null) params.set('take', String(filter.take));
    const qs = params.toString();
    return request<MessagesPage>(`/v1/messages${qs ? `?${qs}` : ''}`);
  },

  get: (id: string) => request<MessageSummary>(`/v1/messages/${id}`),

  events: (id: string) => request<MessageEventSummary[]>(`/v1/messages/${id}/events`),
};
